import React, { Component, PropTypes } from 'react';
import { isEmpty } from 'lodash';
import SponsorUnit from './SponsorUnit';
import AdvertisementUnit from '../AdvertisementUnit';

class SponsorArea extends Component {
  static propTypes = {
      sponsor: PropTypes.object
  }


  render() {
    const { sponsor } = this.props;
    if (isEmpty(sponsor)) return null;

    const { ad, link } = sponsor;
    const sponsorAreaStyle = {
        display: 'inline-block'
    };
    
    let sponsorArea = null;

    if (ad) {
        sponsorArea = <AdvertisementUnit className={ad.className} adData={ad.options} />;
    } else if (link) {
        sponsorArea = <SponsorUnit sponsorImageUri={link.imageUri} sponsorLink={link.uri} />;
    }

    return (
      <div style={sponsorAreaStyle}>
          {sponsorArea}
      </div>
    );
  }

}

export default SponsorArea;



// WEBPACK FOOTER //
// ./app/components/ads/SponsorArea.js